import React, { useState, useEffect, useRef } from 'react';
import ResumePreview from '../../ResumePreview';
import { MOCK_RESUMES } from '../../../templates/mockResumes';

export default function ScaledResumePreview({ templateId, accentColor, resumeData }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(0.25);

  useEffect(() => {
    if (!containerRef.current) return;
    const updateScale = () => {
      // Guard: ref may be null if the component unmounted between observer setup and callback
      if (!containerRef.current) return;
      const width = containerRef.current.getBoundingClientRect().width;
      if (width > 0) {
        setScale(width / 794);
      }
    };
    updateScale();
    const el = containerRef.current;
    const observer = new ResizeObserver(updateScale);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const mockData = MOCK_RESUMES[templateId] || MOCK_RESUMES['harvard_classic'];
  const activeData = resumeData || mockData;

  return (
    <div ref={containerRef} style={{
      width: '100%',
      aspectRatio: '210/250', // Shorter aspect ratio to match card height
      overflow: 'hidden',
      position: 'relative',
      background: '#fff',
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '794px',
        height: '1123px',
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        pointerEvents: 'none',
        userSelect: 'none',
      }}>
        <ResumePreview
          resumeData={activeData}
          template={templateId}
          accentColor={accentColor}
          fontScale={1.0}
          editMode={false}
        />
      </div>
    </div>
  );
}
